import styled from 'styled-components'

export const Badge = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  cursor: pointer;
`

export const Label = styled.span`
  display: block;
  margin-left: 0.2rem;
  font-family: ${({ theme }) => theme.fonts.brand};
  font-size: 1.6rem;
  line-height: 2.3rem;
`

export const SkeletonStarIcon = styled.div`
  display: inline-block;
  clip-path: polygon(
    50% 0%,
    61% 35%,
    98% 35%,
    68% 57%,
    79% 91%,
    50% 70%,
    21% 91%,
    32% 57%,
    2% 35%,
    39% 35%
  );
  width: 2rem;
  height: 2rem;
`
